import { Box, Typography } from '@mui/material'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import { FS_MICRO, ICON_XS } from '../common/theme'

interface TaSourcesFilterProps {
  includeList?: any[]
  excludeList?: any[]
}

function FilterRow({ item }: { item: any }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, py: 0.25 }}>
      {item.type === 'd'
        ? <FolderOutlinedIcon sx={{ fontSize: ICON_XS, color: 'warning.main' }} />
        : <InsertDriveFileOutlinedIcon sx={{ fontSize: ICON_XS, color: 'text.secondary' }} />}
      <Typography variant="caption" sx={{ fontSize: '0.7rem' }}>{item.name}</Typography>
    </Box>
  )
}

export default function TaSourcesFilter({ includeList = [], excludeList = [] }: TaSourcesFilterProps) {
  if (includeList.length === 0 && excludeList.length === 0) return null

  return (
    <Box sx={{ px: 1, py: 0.5, borderBottom: 1, borderColor: 'divider' }}>
      {includeList.length > 0 && (
        <>
          <Typography variant="caption" sx={{ fontSize: FS_MICRO, fontWeight: 600, opacity: 0.55, display: 'block' }}>
            Search In
          </Typography>
          {includeList.map((d, i) => <FilterRow key={i} item={d} />)}
        </>
      )}
      {excludeList.length > 0 && (
        <>
          <Typography variant="caption" sx={{ fontSize: FS_MICRO, fontWeight: 600, opacity: 0.55, display: 'block', mt: includeList.length > 0 ? 0.5 : 0 }}>
            Exclude
          </Typography>
          {excludeList.map((d, i) => <FilterRow key={i} item={d} />)}
        </>
      )}
    </Box>
  )
}
